import React, { useEffect, useRef } from 'react';
import { CLOUD_SERVICES } from '../data/siteData';

export default function Cloud() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          el.querySelectorAll('.rv, .rl, .rr, .rs').forEach((node) => node.classList.add('on'));
          obs.unobserve(el);
        }
      },
      { threshold: 0.07 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="cloud-sec" id="cloud" ref={sectionRef} aria-labelledby="cloud-heading">
      <div className="cloud-bg" aria-hidden="true" />
      <div className="wrap">
        <div className="sec-sp">
          {/* Left info */}
          <div className="cl-left rl">
            <div className="chip" style={{ background: 'rgba(255,255,255,.1)', borderColor: 'rgba(255,255,255,.25)', color: '#fff', marginBottom: '.8rem' }}>
              ☁️ Cloud Consulting
            </div>
            <h2 id="cloud-heading" style={{ fontSize: 'clamp(1.9rem,3.2vw,2.6rem)', fontWeight: 900, letterSpacing: '-.04em', color: '#fff', margin: '.35rem 0 .9rem' }}>
              Azure Cloud Partner
            </h2>
            <p style={{ color: 'rgba(255,255,255,.7)', lineHeight: 1.85, marginBottom: '1.6rem' }}>
              Certified Microsoft Azure consultants with deep experience in enterprise cloud architecture,
              migration, and managed services. We help you go cloud-native — securely and cost-effectively.
            </p>

            <div className="cl-stats">
              {[
                { n: '35+', l: 'Cloud Projects' },
                { n: '40%', l: 'Avg Cost Saved' },
                { n: '99.9%', l: 'Uptime SLA' },
              ].map((s) => (
                <div className="cl-stat" key={s.l}>
                  <div className="cl-stat-n">{s.n}</div>
                  <div className="cl-stat-l">{s.l}</div>
                </div>
              ))}
            </div>

            <div style={{ display: 'flex', gap: '.75rem', flexWrap: 'wrap', marginTop: '2rem' }}>
              <a href="#contact" className="btn btn-green" onClick={(e) => {
                e.preventDefault();
                document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}>
                Get Cloud Assessment →
              </a>
              <a href="https://wa.me/918123629993?text=I need cloud consulting" target="_blank" rel="noopener noreferrer" className="btn btn-ghost">
                💬 Quick Chat
              </a>
            </div>
          </div>

          {/* Right: service cards */}
          <div className="cl-right">
            <div className="cl-grid">
              {CLOUD_SERVICES.map((svc, i) => (
                <div
                  className="cl-card rs"
                  key={svc.title}
                  style={{ transitionDelay: `${i * 0.07}s` }}
                >
                  <div className="cl-ic">{svc.icon}</div>
                  <div className="cl-card-title">{svc.title}</div>
                  <div className="cl-card-desc">{svc.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
